import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/auth'
import localeReducer from './slices/lannguage'
import jobsReducer from './slices/jobs'

const store = configureStore({
  reducer: {
    auth: authReducer,
    locale: localeReducer,
    jobs: jobsReducer,
  },
})


export {store};
